/* eslint-disable */
import React from 'react';
import ROUTES from 'config/routes';
import COMPANY_DATA from 'config/companyData';
import { StyledDiv, Header } from '../styled';
import Email from 'shared/components/Email';

const { COMPANY_NAME, RODO_EMAIL, COMPANY_STREET, COMPANY_ZIP_CODE, BOK_EMAIL, PRIVACY_POLICY_LAST_UPDATE } =
  COMPANY_DATA;

function PrivacyPolicyEn(): JSX.Element {
  const [show, setShow] = React.useState(false);

  return (
    <>
      <StyledDiv>
        <StyledDiv>
          <Header>Privacy Policy</Header>
        </StyledDiv>
        <StyledDiv>
          <p>
            The owner of the TrustMate.io Internet Service located at the URL https://trustmate.io (hereinafter referred
            to as the &quot;Internet Service&quot;) and the TrustMate.io feedback management tool is the TrustMate S.A..
            This document, in accordance with the &quot;General Data Protection Regulation&quot; (GDPR) and all
            applicable laws, describes how your personal data will be used on the https://trustmate.io website for
            purposes related to informing about our services, displaying the website and its maintenance, improvement,
            and management to ensure the highest comfort of using our services whenever you interact with us in the
            digital world.
          </p>
          <p>
            Here you will find out what tools for marketing purposes, gathering and building website statistics,
            cookies, plugins, beacons, pixels, tags, scripts, we use on our website and how they work and how you can
            object to processing your personal data as well as how you can delete the collected data.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Data administrator TrustMate S.A.</h3>
          <p>
            On the https://trustmate.io website, your information will be processed by the TrustMate S.A. company, which
            is the administrator of this website.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Contact regarding personal data</h3>
          <p>
            The person dedicated to personal data is the Data Protection Officer - this is the person with whom you can
            contact in all matters related to the processing of your personal data and the exercise of rights related to
            their processing.
          </p>
          <div>
            Contact details of our Data Protection Officer <Email email={RODO_EMAIL} setVisible={setShow} visible={show} /> lub
            <address>
              <div>{COMPANY_NAME}</div>
              <div>{COMPANY_STREET}</div>
              <div>{COMPANY_ZIP_CODE}</div>
            </address>
            <div>Please add the &quot;GDPR&quot; superscription on the envelope.</div>
          </div>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Personal Data</h2>
        </StyledDiv>
        <StyledDiv>
          <h3>What personal data do we collect about you and what do we do with them?</h3>
          <ol>
            <li>
              <b>Identification data</b> - this is the information we use to identify the user and check his/her
              identity. They include: name, email address, unique customer number, nickname, password, social media
              identifiers.
            </li>
            <li>
              <b>Contact details</b> - these are the data we use to contact you in order to share promotional
              information, provide services, share news about us, and answer your questions. These include, for example:
              phone number, billing address, email address, Messenger ID and name on social networks.
            </li>
            <li>
              <b>Purchase information</b> - this is information that we use for the purposes of processing the
              partner&#39;s order. They include shopping cart contents, delivery data, shipping address, and billing
              address, partner&#39;s order number and purchase history in the TrustMate S.A.
            </li>
            <li>
              <b>Information from social networking sites</b> - this is information that we use to understand you better
              to build better relationships and focus our marketing activities on messages that will be useful and
              interesting to you (based on your online behavior) and facilitate interactions conducted through social
              networking sites. This involves all publicly available information from social networking sites, including
              usernames on social networking sites, interactions and posts on social networking sites, &quot;likes&quot;
              and other reactions, people with whom you are associated with on social networking sites. This information
              is made available to us directly or indirectly through social networking sites (e.g., Facebook) via
              intermediaries with whom contracts bound us.
            </li>
            <li>
              <b>Device information</b> - this is information that we use to secure our network and improve our services
              and efficiency. They include, for example: IP address, date and time of visit, duration of visit to our
              website, referring URL (if the user comes to our website from another website or through the ad), visited
              subpages of our website, type of internet browser, device type, its versions, and operating system.
            </li>
            <li>
              <b>Correspondence</b> - this is information that we use for quality control purposes and to process your
              requests or comply with legal requirements. They include, for example: recordings of phone calls made by
              users with the Customer Service Center or vice versa, email correspondence with the staff of the TrustMate
              SA, and postal correspondence with the staff of the TrustMate SA.
            </li>
          </ol>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Objectives</h2>
        </StyledDiv>
        <div>
          <h3>Why do we use personal data</h3>
          <p>
            We use personal data to provide the best possible quality of service and we constantly work on improving it.
          </p>
          <p>In particular, we use personal data for the following purposes:</p>
          <ol>
            <li>
              <b>Sale of our products and services</b> - we use personal data to process the service you ordered, check
              the payment we received, ensure compliance with the requirements of our Terms (regarding the sale of
              products), and deliver the ordered products.
            </li>
            <li>
              <b>
                We use personal data to process the service you ordered, check the payment we received, ensure
                compliance with the requirements of our Terms (regarding the sale of products), deliver the ordered
                products
              </b>{' '}
              - we gather and store certain information from users from devices, end devices and Internet browsers
              (e.g., using cookies, pixel tags or other technical solutions for targeting). It allows us to remember
              users&#39; preferences regarding browsing our websites and shopping on them. It also allows us to provide
              relevant information tailored to the needs of users. For more information on how we use online tracking
              technologies such as cookies, tags, and other types of code, see the section entitled &quot;Cookies.&quot;
            </li>
            <li>
              <b>Personal data storage</b> - we&#39;ll store users&#39; personal data until a request for its removal is
              received or within the period required by law.
            </li>
            <li>
              <b>Offering, adjusting and managing our products and services</b> - we take appropriate technical and
              organizational steps to protect personal data against accidental or unlawful damage or accidental loss,
              modification, unauthorized use, disclosure or access (especially when the processing involves the transfer
              of data) and against all other illegal types of processing and misuse.
            </li>
            <li>
              <b>Informing about products and services</b> - we use users&#39; personal data to send notifications and
              news about our products and services based on the preferences, interests, participation, and community of
              our users. This is treated as a &quot;legitimate economic interest&quot; aimed at ensuring that our
              company thrives.
            </li>
            <li>
              <b>Protection of our products and services</b> - we&#39;ll be able to continue to prosper as an enterprise
              if we strongly defend our corporate and economic interests. It includes ensuring that orders and fees are
              legal (fraud prevention). This is treated as a &quot;legitimate economic interest&quot; aimed at ensuring
              that our company thrives.
            </li>
            <li>
              <b>Care of products and services</b> - we use user data to maintain their accounts on https://trustmate.io
              Internet Service. Your account will be used primarily for purposes related to the provision of services in
              accordance with the
              <a href={ROUTES.USER_REGULATIONS}>
                <b>Terms and Conditions of TrustMate for Users</b>
              </a>
              and{' '}
              <a href={ROUTES.BUSINESS_REGULATIONS}>
                <b>Terms and Conditions of TrustMate for Internet Service partners</b>
              </a>
            </li>
          </ol>
        </div>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Who do we share your personal data with?</h2>
        </StyledDiv>
        <StyledDiv>
          <p>
            With a sense of civic responsibility, we may be constrained to share data with the following types of
            entities (to the extent permitted and required by law):
          </p>
          <ol>
            <li>
              <b>Authorities and law enforcement agencies</b> - representatives of government authorities and/or law
              enforcement agencies, if it&apos;s necessary for the purposes set out in this information if it&apos;s
              required by law or required for the legal protection of our legitimate interests in accordance with
              applicable law.
            </li>
            <li>
              <b>Partners</b> - we can run cooperative programs, events, or promotions with other companies on their
              websites or in their applications. Our partners will only use the personal data of users if they agree to
              do so. If you do not wish your personal data to be gathered or shared with companies other than the
              TrustMate SA, you may not participate in such programs, promotions or events.
            </li>
            <li>
              <b>Potential buyer advisor</b> - if our enterprise is sold or merged with another enterprise, your
              personal data will be disclosed to our advisors, all advisors of the potential buyer, and the new owner of
              the enterprise.
            </li>
            <li>
              <b>External processing service providers</b> - personal data on behalf of the TrustMate SA, for example
              for processing data related to credit cards and payments, storage (data hosting), data and service
              management, distribution of email, research and analytical work, as well as brand management, product
              promotions, and administration of selected services and functions. By using services provided by
              third-party suppliers, we conclude agreements obliging them to implement appropriate technical and
              organizational measures to protect users&#39; personal data.
            </li>
          </ol>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>On what legal grounds do we use personal data</h2>
            <ol>
              <li>
                <b>Consent</b> - when a user visits the https://trustmate.io Internet Service, signs up, buys a product,
                gives feedback, participates in mediation, participates in the life of our community or creates an
                account, he consents to our use of personal data provided by him for specific purposes in accordance
                with this information. We store consents to the use of personal data in a particular way.
              </li>
              <li>
                <b>Compliance with legal provisions</b> - we process and use users&#39; personal data to comply with
                legal obligations arising from applicable laws.
              </li>
              <li>
                <b>Contractual obligations</b> - we process users&#39; personal data and use them to fulfill our
                contractual obligations in order to be able to provide users with ordered products and services.
              </li>
              <li>
                <b>Legitimate interest</b> - we&#39;ll process and use our users&#39; personal data to provide and
                improve our products and services by sending marketing correspondence and research and development
                questionnaires.
              </li>
            </ol>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>Your rights, and how can they be enforced?</h2>
            <p>
              As a consumer living in EU, you have the following rights regarding personal data under the GDPR. However,
              you must know that we&#39;ll comply with it to the extent that it&#39;s required from us. In some cases,
              when the law requires us to keep your data unchanged, we&#39;ll reject your request. In such a case,
              we&#39;ll justify our decision.
            </p>
          </StyledDiv>
          <StyledDiv>
            <h3>Access to personal data</h3>
          </StyledDiv>
          <StyledDiv>
            <p>You have the right to apply for access to your personal data, including to the following information:</p>
            <ol type="a">
              <li>why do we store your personal data</li>
              <li>what categories of personal data do we store</li>
              <li>what do we do with your personal data</li>
              <li>who has the access to your personal data (and where this entity is located)</li>
              <li>where your personal data can be transferred</li>
              <li>how long do we store your personal data</li>
              <li>if you didn&#39;t provide us with your personal data directly, how did we obtain it</li>
              <li>what rights do you have under applicable laws?</li>
              <li>whether we use your personal data to make decisions automatically and how we do it</li>
            </ol>
            <p>
              If you want to get a copy of your personal data that we store, please send a request to the following
              email address: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
            </p>
          </StyledDiv>
          <StyledDiv>
            <p>
              <b>Adjustment of your personal data </b>– you have the right to check whether your personal data is
              correct and complete. If you have an account on the Internet Service, please log in to it and make the
              required changes. If you need further assistance, please contact our Customer Service Center at{' '}
              <Email email={BOK_EMAIL} setVisible={setShow} visible={show} />
            </p>
            <p>
              <b>Data portability </b>– you have the right to obtain a copy of your personal data in order to transfer
              it to another company. In such a case, please send a request to the following address:{' '}
              <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
            </p>
            <p>
              <b>Lodging a complaint to the regulatory/supervisory authority </b>- jif you&#39;re not satisfied with the
              way we have complied with consumer rights or our &quot;Privacy Policy,&quot; you have the right to lodge a
              complaint with the supervisory authority in the Member State of the European Union where you are.
            </p>
            <p>
              <b>Removing personal data from the TrustMate</b>
              if you no longer want to have contact with us or you don&#39;t want us to store your personal data, you
              have the right to ask us to delete all personal data related to you from our systems. To that end, please
              send a request to the following email address: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />. However,
              please keep in mind that there may be legal obligations that may force us to reject your request or keep
              certain information.
            </p>
            <p>
              <b>Limiting the ways in which we use and process your personal data </b>– you also have the right to ask
              us to stop using your personal data in a certain way (e.g. if you don&#39;t want us to profile data for
              marketing purposes or send you marketing messages). To this purpose, please send a request to the
              following email address: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
            </p>
            <p>
              If you have questions, concerns, or complaints related to the privacy of personal data rights, please
              contact us at: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />.
            </p>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>Questions and complaints about personal data?</h2>
          </StyledDiv>
          <StyledDiv>
            <p>
              You can contact the Data Protection Officer at: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
            </p>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>The scope of personal data processed on TrustMate.io</h2>
          </StyledDiv>
          <StyledDiv>
            <ol>
              <li>
                <h3>Visiting the Internet Service - Reports</h3>
                <p>
                  When you open our website https://trustmate.io, it gathers so-called operating data, including the IP
                  address, and saves them in the form of logs. The log consists of: name of the page displayed,
                  downloaded files, date and time of download, amount of data transferred, notification of successful
                  download, browser type along with its version, operating system, so- called URL referrers (previously
                  visited website) and requesting provider. It&#39;s not possible to identify you based on this data.
                </p>
                <p>
                  When visiting our website, cookies are saved on the end device (laptop, tablet, smartphone, or PC).
                  Details of cookies used on our website, their purpose, and instruction on how to delete cookies can be
                  found in the further part of the cookie policy.
                </p>
                <p>
                  We collect logs, including IP addresses, to provide users with a smooth connection and convenient use
                  of our website. Logs are also gathered to assess system security and stability as well as for
                  administrative purposes. Cookies allow us to create an Internet Service and website that are more
                  user-friendly, giving us the ability to determine whether a user has already visited any of our pages.
                  With cookies, we also receive information on user behavior on our website and information about
                  phrases searched that led users to our website.
                </p>
                <p>
                  The data contained in the logs, including the IP address, is only used for technical optimization and
                  to optimize the settings on our website and to protect our systems (e.g., in the event of a
                  cyber-attack or incident related to system security). When launching our website, it&#39;s not
                  possible to identify a person based on data from the log, including the IP address. Identification is
                  only possible if you, at the same time, log in to your customer account. In this case, we can assign
                  an IP address to the user. Through cookies, we can e.g., find out if and for what purpose you visited
                  our pages and whether you registered with us using a specific ID, as well as when you used this ID
                  again.
                </p>
                <p>
                  The internal data processing center and external providers are responsible for hosting our website and
                  all data.
                </p>
              </li>
            </ol>
            <table>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Purpose of data processing</th>
                  <th>Provider details &amp; privacy policy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div>Amazon Webservices Inc.</div>
                    <div>410 Terry Drive Ave North</div>
                    <div>WA 98109-5210 Seattle, USA</div>
                  </td>
                  <td>
                    Hosting and backup Data processing only takes place in Amazon Web Services data centers located in
                    Europe.
                  </td>
                  <td>
                    <div>
                      <a href="https://aws.amazon.com/de/data-protection/">
                        https://aws.amazon.com/de/data-protection/
                      </a>
                    </div>
                    <div>
                      <a href="https://aws.amazon.com/en/compliance/eu-data-protection/">
                        https://aws.amazon.com/en/compliance/eu-data-protection/
                      </a>
                    </div>
                    <div>
                      <a href="https://aws.amazon.com/en/compliance/data-center/data-centers/">
                        https://aws.amazon.com/en/compliance/data-center/data-centers/
                      </a>
                    </div>
                    <div>
                      <a href="https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4&status=Active">
                        https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4&status=Active
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <b>Data storage period: </b>
              Logs, including the IP address, are automatically removed after six (6) months from its collection. Until
              then, the IP address will be anonymized and saved only for administrative (technical) purposes.
            </div>
            <div>
              <b>Legal foundation: </b>
              Art. 6, paragraph 1, letter f of GDPR.
            </div>
            <div>
              <b>Statutory or contractual requirement to provide personal data: </b>
              Providing the aforementioned personal data is not a statutory or contractual requirement. However, without
              an IP address and cookies, the services and operation of our website cannot be guaranteed, and individual
              applications and services may not be available or work in a limited manner.
            </div>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>Visiting https://trustmate.io - Website analysis</h2>
          </StyledDiv>
          <StyledDiv>
            <p>
              We use so-called tracking and internet statistics tools. Collecting access data on our website and
              analyzing user behavior is used to optimize our offer and improve the quality of the Internet Service.
            </p>
            <p>
              These tools examine how and from where users come to our website, which areas of our website are more
              popular than others, and how often and how long individual sub-pages and categories are viewed. We can
              also determine what phrases users searched for and which pages they visited, as well as assess how many
              users visited our website in total and which information and offers are the most popular. The goal is to
              create a user-friendly offer and presence on the Internet by using the collected data.
            </p>
            <p>
              By statistical analysis of user profiles, we can create a picture of the functionality and popularity of
              our website. It concerns the analysis of the website visiting frequency with a specific group of business
              cards and the number of visitors.
            </p>
            <p>
              The following providers of tracking tools and tools for creating website statistics process the access
              data on our behalf to perform user analysis and to prepare statistics for us. To this purpose, we have
              entered into a contract of entrusting the processing of personal data with providers.
            </p>
            <table>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Tool</th>
                  <th>Provider details &amp; privacy policy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div>Google Inc.</div>
                    <div>1600 Amphitheatre Parkway</div>
                    <div>Mountain View, CA 94043</div>
                    <div>USA</div>
                  </td>
                  <td>Google Analytics</td>
                  <td>
                    <div>
                      <a href="www.google.com/policies/">www.google.com/policies/</a>
                    </div>
                    <div>
                      <a href="https://support.google.com/analytics/answer/6004245?hl=en">
                        https://support.google.com/analytics/answer/6004245?hl=en
                      </a>
                    </div>
                    <div>
                      <a href="https://www.privacyshield.gov/participant">Privacy shield</a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </StyledDiv>
          <StyledDiv>
            <p>
              <b>Data storage period: </b>
              The following providers of tracking tools and tools for creating website statistics process the access
              data on our behalf to perform user analysis and to prepare statistics for us. To this purpose, we have
              entered into a contract of entrusting the processing of personal data with providers.
            </p>
            <p>
              <b>Legal foundation: </b>
              Art. 6, paragraph 1, letter f of GDPR.
            </p>
            <p>
              <b>Statutory or contractual requirement to provide personal data: </b>
              Providing the aforementioned personal data is not a statutory or contractual requirement.
            </p>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>Visiting https://trustmate.io - Advertising</h2>
          </StyledDiv>
          <StyledDiv>
            <p>
              The website also uses so-called tracking tools that help to customize the displayed ads to the interests
              of users. With these tools, we can show or set to display on our pages personalized advertisements that
              have been selected (automatically) according to the area of ​​interest of visitors. Ads tracking is
              usually done using advertising IDs, through which, e.g., by employing cookies, the advertising network
              provider creates user profiles. Ads are presented based on the cookie profile when the website is opened.
              By using the so-called tracking pixels on various websites, the first time the user visits the affiliate
              partner&#39;s website, cookies are saved on the end device by the affiliate partner. With the help of such
              a remarketing campaign, the user can be &quot;tracked&quot; on the internet, and particularly interesting
              offers can be shown to him. In many cases, tracking is done using so-called browser fingerprints that use
              information such as user screen resolution settings, color depth, time zone, and installed plugins to
              recognize a user or user group.
            </p>
            <p>
              Through the so-called affiliate networks, we advertise our products on third-party websites. By clicking
              on the advertisement, the user is redirected to our sales proposal. The third-party will receive the order
              ID for commission settlement only if you use the service.
            </p>
            <p>
              By using tracking tools, we can create a better offer for partners, visitors, and interested parties.
              Tracking tools and related advertising campaigns allow us or third parties to monetize Internet Service
              traffic through the use of ads. Besides, user behavior enables us to determine which areas of our website
              are most popular among visitors so that we can tailor ads accordingly. As a result, tracking tools can
              collect information about where visitors come from and which areas of the website they visited, as well as
              how often and how long they viewed individual sub-pages and categories. A frequently used advertising
              measure is retargeting and remarketing campaigns, during which users are addressed at a different time and
              place on the Internet, e.g., by displaying products that the user has previously viewed on other websites
              or products that might interest him.
            </p>
            <p>
              The following providers of website statistics tools process the access data on our behalf to perform user
              behavior analysis and create personalized advertising. To this purpose, we have entered into a contract of
              entrusting the processing of personal data with providers.
            </p>
            <p>
              Details and further information about the providers of these types of tools can be found in tab concerning
              the right to object to the processing of personal data.
            </p>
            <p>
              Despite our best efforts, it may turn out that the following list is not complete and doesn&#39;t indicate
              all of the Company&#39;s Trusted Partners. This is because some of our Trusted Partners use their
              subcontractors or outsource placing ads on our advertising space through another Trusted Partner, which is
              e.g., a media agency or advertising network.
            </p>
          </StyledDiv>
          <StyledDiv>
            <table>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Tool</th>
                  <th>Provider details &amp; privacy policy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div>Facebook, Inc.</div>
                    <div>1601 South California Avenue</div>
                    <div>Palo Alto</div>
                    <div>CA 94304</div>
                    <div>USA</div>
                  </td>
                  <td>Facebook Connect</td>
                  <td>
                    <div>
                      <a href="https://www.facebook.com/about/privacy/">https://www.facebook.com/about/privacy/</a>
                    </div>
                    <div>
                      <a href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen">
                        https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Facebook, Inc.</div>
                    <div>1601 South California Avenue</div>
                    <div>Palo Alto</div>
                    <div>CA 94304</div>
                    <div>USA</div>
                  </td>
                  <td>
                    <div>Facebook Custom Audiences</div>
                    <div>Facebook Pixel</div>
                  </td>
                  <td>
                    <div>
                      <a href="https://www.facebook.com/about/privacy/">https://www.facebook.com/about/privacy/</a>
                    </div>
                    <div>
                      <a href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen">
                        https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>Google Inc(Google)</div>
                    <div>1600 Amphitheatre Parkway</div>
                    <div>Mountain View</div>
                    <div>CA 94043</div>
                    <div>USA</div>
                  </td>
                  <td>
                    <div>Google AdWords User Lists</div>
                    <div>Google Dynamic Remarketing</div>
                    <div>Google Analytics Audiences</div>
                  </td>
                  <td>
                    <div>
                      <a href="https://www.google.com/policies/technologies/ads/">
                        https:/www.google.com/policies/technologies/ads/
                      </a>
                    </div>
                    <div>
                      <a href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active">
                        Privacy shield
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <b>Data storage period: </b>
              Details about cookies used in technological tracking tools, storage period, and information on the
              procedure to remove cookies can be found in the cookie tab further in the document.
            </p>
            <p>
              <b>Legal foundation: </b>
              Art. 6, paragraph 1, letter f of GDPR.
            </p>
            <p>
              <b>Statutory or contractual requirement to provide personal data: </b>
              Providing the aforementioned personal data is not a statutory or contractual requirement.
            </p>
            <p>
              <b>Profiling: </b>
              By using tracking tools, we can evaluate and analyze the area of interest and behavior of our website
              users. To this end, our partner or we create a pseudonymous user profile.
            </p>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>
              Visiting https://trustmate.io - Invitations, emails, correspondence, account management, chat, customer
              dashboard
            </h2>
            <p>
              We&#39;ll process data: email address, title, first name, company address, invoice address, payment
              details, registered users&#39; login details, customer number, order number (for registered users), IP
              address, cookies.
            </p>
            <p>
              The processing of this data will take place in order to enable the provision of services by electronic
              means, the complete use of the TrustMate.io portal along with sub-pages, and prevent technical problems
              related to the services of the TrustMate S.A.. Thanks to cookies, we&#39;ll be able to handle chat
              conversations with customer service, remember the user&#39;s session, and restore him to the chat in case
              of abandonment. Besides, we&#39;ll contact you regarding the handling of requests, informing about the
              service provided and functionalities.
            </p>
            <p>
              We process and remove confirmation of subscription orders, according to the storage period, regulated by
              tax and commercial law, unless you have given us permission to use them for a longer period.
            </p>
            <p>
              If you cooperate with the TrustMate, the data is additionally stored for the period during which the
              account is active. Account removal is possible at any time and can be made based on a written request sent
              to the email address:
              <Email email={BOK_EMAIL} setVisible={setShow} visible={show} /> or {COMPANY_NAME}, {COMPANY_STREET},{' '}
              {COMPANY_ZIP_CODE}.
            </p>
            <p>
              Depending on the payment methods chosen, your payment details will be forwarded to the appropriate payment
              service provider. The responsibility for the information about your payments rests upon the payment
              service provider.
            </p>
            <p>
              Without providing the aforementioned data, it&#39;s impossible to provide services by the TrustMate S.A..
            </p>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>Log in https://trustmate.io - Facebook, Google, E-mail</h2>
          </StyledDiv>
          <StyledDiv>
            <p>
              Facebook Connect is a service that allows users of the Facebook social network to log in to our website
              and add reviews without email acceptance using a Facebook network profile, without the need to create a
              separate account. To use the Facebook Connect plugin, the user must have a Facebook account. By using
              Facebook Connect, at least the user&#39;s full name will be connected to our account. More information
              will be displayed to the user in the window. We have no influence on the collection of data, the purpose
              of their processing, or the period of storage. We also don&#39;t have any information regarding the
              deletion of data collected by the plugin provider. We send login details and your IP address to the social
              network.
            </p>
            <p>
              A Google Account is a service that allows users of Google&#39;s email operator to log in to our website
              and add reviews without email acceptance using a Google email account, without the need to create a
              separate account. To use the Google plugin, you must have an email account at Google. By using Google
              login, at least the user&#39;s full name will be connected to our account. More information will be
              displayed to the user in the window. We have no influence on the collection of data, the purpose of their
              processing, or the period of storage.
            </p>
            <p>
              If you register using the Facebook Connect plugin or Google Account by clicking the button clearly
              confirming the fact of logging in using one of the above solutions, you&#39;ll be automatically
              transferred to the operator offering the solutions chosen by you. There you can log in using your login
              details. After successful verification, a connection will be created between your Google or Facebook
              account (depending on your choice) and our website through which data will be sent.
            </p>
            <p>Thanks to this solution you can use our website without creating a separate account with your data.</p>
            <p>
              In case you don&#39;t decide to sign up using the above solutions, we give you the option of creating a
              customer account by registering via email.
            </p>
          </StyledDiv>
        </StyledDiv>
        <StyledDiv>
          <StyledDiv>
            <h2>Cookies</h2>
          </StyledDiv>
          <StyledDiv>
            <h3>What are cookies?</h3>
            <p>
              Cookies are small text files saved on a computer or mobile device during a user&#39;s visit to a given
              website. For convenience, the term &quot;cookies&quot; as used herein includes techniques such as cookies,
              flash cookies, and web beacons. They don&#39;t take up much space and are removed automatically when they
              expire. Some cookies expire when the user&#39;s session ends, while others are saved for a limited time.
              Cookies also help in providing services on our website, personalizing content, and adjusting and analyzing
              ads.
            </p>
          </StyledDiv>
          <StyledDiv>
            <h3>What cookies do we use?</h3>
            <p>We divide cookies into five categories depending on their purpose and function:</p>
            <ol>
              <li>
                We use <b>&quot;necessary&quot; cookies</b> on our website so that you can navigate through our website
                and use its basic functions.
              </li>
              <li>
                We use <b>&quot;performance&quot; cookies</b> to improve the use of our website. These files gather
                information on how our websites are used, e.g., about the web browser and operating system used by the
                user, the domain name of the website from which you came to our website, the number of visits, average
                visit time, and the pages opened.
              </li>
              <li>
                We use <b>&quot;analytical&quot; cookies</b> to make our Internet Service more user-friendly. Thanks to
                these files, we can determine how users use our website and, e.g., based on what preferences and search
                phrases our website has been opened.
              </li>
              <li>
                We use <b>&quot;advertising&quot; cookies</b>, to provide you with content tailored to your needs.
                Advertising cookies are also used to measure and control the effectiveness of advertising campaigns.
                Marketing cookies record whether a given website is visited and what content is used. This information
                may also be transferred to external entities, e.g., advertisers, and are often linked to the functions
                of the website of these entities (third party cookies).
              </li>
              <li>
                <b>&quot;Social&quot; cookies</b> are used by social networking sites, e.g., login details for a social
                networking portal can be used to sign up on our website or use chat.
              </li>
            </ol>
          </StyledDiv>
          <StyledDiv>
            <h3>Why do we use cookies?</h3>
            <p>
              {COMPANY_NAME} uses cookies primarily to ensure user satisfaction from visits to our website, as well as
              for advertising purposes during future visits to other websites and conducting Internet Service analytics.
            </p>
          </StyledDiv>
          <div className="row d-block">
            <h3>What can I do if I DON&#39;T LIKE COOKIES?</h3>
            <p>
              The user may change the browser settings to delete or prevent the storage of some cookies on a computer or
              mobile device without the explicit consent of the user. Information on managing cookie settings can be
              found in the &quot;Help&quot; section. Find out how it works in your browser by clicking here:
            </p>
            <p>
              <b>Internet Explorer:</b>{' '}
              https://support.microsoft.com/help/17442/windows-internet-explorer-delete-manage-cookies
            </p>
            <p>
              <b>Mozilla Firefox:</b> http://support.mozilla.com/en-US/kb/Cookies
            </p>
            <p>
              <b>Google Chrome:</b> http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647
            </p>
            <p>
              <b>Safari:</b> http://support.apple.com/kb/PH5042
            </p>
            <p>
              <b>Opera:</b> http://www.opera.com/browser/tutorials/security/privacy/
            </p>
            <p>
              <b>Adobe (flash cookies)</b> http://www.adobe.com/privacy/policies/flash-player.html
            </p>
            <p>
              You can also prevent the automated loading of so-called scripts. The NoScript add-on allows the user to
              run JavaScript, Java applets, and other plugins only through trusted domains selected by the user.
              Information and instructions on how to use this feature can be found on the websites of browser providers.
            </p>
          </div>
          <StyledDiv>
            <h3>How often is the cookie statement updated?</h3>
            <p>
              This cookie statement may be updated from time to time to reflect, for example, changes in cookies we use
              or for other operational, legal, or regulatory reasons. Therefore, you should regularly return to this
              information about cookies to have current knowledge about the use of cookies and related solutions. The
              date of the last update appears in the upper part of this cookie statement.
            </p>
          </StyledDiv>
          <div>
            <h3>Where can more information be obtained?</h3>
            <p>
              Questions about the cookies we use or other solutions can be sent to the following email address:{' '}
              <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />.
            </p>
          </div>
          <StyledDiv>
            <p>Last updated: {PRIVACY_POLICY_LAST_UPDATE}.</p>
          </StyledDiv>
        </StyledDiv>
      </StyledDiv>
    </>
  );
}

export default PrivacyPolicyEn;
